class CharmOptions extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.#onRadioChange);
  }

  get selectedValue() {
    return this.querySelector('input[type="radio"]:checked')?.value ?? null;
  }

  get necklaceVariantId() {
    return this.querySelector('input[value="charm-necklace"]')?.dataset.necklaceVariantId ?? null;
  }

  get braceletVariantId() {
    return this.querySelector('input[value="charm-bracelet"]')?.dataset.braceletVariantId ?? null;
  }

  get selectedPrice() {
    const raw = this.querySelector('input[type="radio"]:checked')?.dataset.price;
    return raw ? parseInt(raw, 10) : null;
  }

  #onRadioChange = () => {
    this.#syncStickyPrice();
    this.dispatchEvent(
      new CustomEvent('charm-option-change', {
        bubbles: true,
        detail: {
          value: this.selectedValue,
          price: this.selectedPrice,
          necklaceVariantId: this.necklaceVariantId,
          braceletVariantId: this.braceletVariantId,
        },
      })
    );
  };

  #syncStickyPrice() {
    const price = this.selectedPrice;
    if (price === null) return;
    const symbol = window.ThatWorks?.shopSettings?.currency_symbol ?? '£';
    const formatted = symbol + (price / 100).toFixed(2);
    const priceEl = document.querySelector('#atc_sticky_container .product_price');
    if (priceEl) priceEl.textContent = formatted;
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.#onRadioChange);
  }
}

if (!customElements.get('charm-options')) {
  customElements.define('charm-options', CharmOptions);
}
